<template>

    <div class="backpack-empty-modal modal fade" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-pdv">
            <div class="modal-content">
                <div class="modal-title">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <div class="backpack-title">
                        <img src="/images/iconos/Flecha-derecha.svg" alt="">
                        <h4>Tu mochila de compras</h4>
                    </div>
                </div>

                <div class="main-content">
                    <div class="main-content-empty-backpack">
                        <img src="/images/iconos/mochila-vacia.png" alt="">
                        <div class="ml-4">
                            <h3>TU MOCHILA DE COMPRAS ESTÁ VACÍA</h3>
                            <p>Eliminaste los programas que habías seleccionado</p>

                            <div class="row">
                                <div class="col-8">
                                    <router-link :to="{name: 'Landing'}" class="btn-pdv-primary w-100 text-center">ELIGE TU PROGRAMA</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {


    }
</script>

<style scoped lang="scss">
    .backpack-empty-modal{
        @include media-breakpoint-down(sm){
            padding-right: 0 !important;
        }
        .modal-pdv{
            max-width: 951px;
            @include media-breakpoint-down(sm){
                margin: 65px 0 0;
            }
            .modal-content{
                padding: 35px 40px;
                border-radius: 1px;
                border: 1px solid #000;
                box-shadow: 0 0 12px 3px #00000038;
                height: 566px;
                .modal-title{
                    button.close{
                        position: absolute;
                        right: 15px;
                        top: 15px;
                        opacity: 1;
                        span{
                            font-size: 30px;
                            color: $brown-light;
                        }
                    }
                    .backpack-title{
                        display: flex;
                        align-items: center;
                        margin-bottom: 11px;
                        img{
                            margin-right: 5px;
                        }
                        h4{
                            font-size: 18px;
                            line-height: 21px;
                            margin-bottom: 0;
                            @include alternative-regular;
                        }

                    }
                }
                .main-content{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    .main-content-empty-backpack{
                        display: inline-flex;
                        align-items: center;
                        width: 70%;
                        img{
                            width: 183px;
                        }
                        h3{
                            font-size: 20px;
                            line-height: 23px;
                            @include alternative-bold;
                        }
                        p{
                            font-size: 18px;
                            line-height: 26px;
                            @include alternative-regular;
                            margin-bottom: 19px;
                        }
                    }
                }
            }

        }
    }

</style>